import C from '../constants'
import sharedReducers from '../../../shared/reducers'
import { combineReducers } from 'redux'

export const user = (state=null, action) => {
  switch (action.type) {
    case C.SET_PRODUCT:
      return {
        ...state,
        guest: {
          ...state.guest,
          product: action.payload
        }
      }
    case C.SET_ARRIVAL:
      return {
        ...state,
        guest: {
          ...state.guest,
          arrival: action.payload
        }
      }
    case C.SET_PICKUP:
      return {
        ...state,
        guest: {
          ...state.guest,
          pickup: action.payload
        }
      }
    case C.SET_DEPARTURE:
      return {
        ...state,
        guest: {
          ...state.guest,
          departure: action.payload
        }
      }
    case C.SET_DEPARTURE_PICKUP:
      return {
        ...state,
        guest: {
          ...state.guest,
          departure_pickup: action.payload
        }
      }
    case C.SET_USER:
      return action.payload
    default:
      return state
  }
}

export const localProfileElements = (state=false, action) =>
  (action.type === C.SET_LOCAL_PROFILE_ELEMENTS) ?
    action.payload :
    state;

export const registered = (state=false, action) =>
  (action.type === C.SET_REGISTERED) ?
  	action.payload :
  	state;

export const referral = (state=false, action) =>
  (action.type === C.SET_REFERRAL) ?
    action.payload :
    state

export const affiliate = (state=false, action) =>
  (action.type === C.SET_AFFILIATE) ?
  	action.payload :
  	state;

export const environment = (state=false, action) =>
  (action.type === C.SET_ENVIRONMENT) ?
  	action.payload :
  	state;

export const products = (state=false, action) =>
  (action.type === C.SET_PRODUCTS) ?
  	action.payload :
  	state;

export const arrival_times = (state=false, action) =>
  (action.type === C.SET_ARRIVAL_TIMES) ?
  	action.payload :
  	state;

export const completed = (state=false, action) =>
  (action.type === C.SET_COMPLETED) ?
  	action.payload :
  	state

export const guest_kind = (state=false, action) =>
  (action.type === C.SET_GUEST_KIND) ?
  	action.payload :
  	state

export const guest_kind_unknown_place = (state=false, action) =>
  (action.type === C.SET_GUEST_KIND_UNKNOWN_PLACE) ?
  	action.payload :
  	state

export const vaccinationInfo = (state=[], action) => 
  (action.type === C.SET_VACCINATION_INFO) ?
    action.payload :
    state

export const vaccinationOptions = (state=[], action) => 
  (action.type === C.SET_VACCINATION_OPTIONS) ?
    action.payload :
    state

export const onshore = (state = false, action) =>
  (action.type === C.SET_ONSHORE) ?
    action.payload :
    state

export const uploader = (state = {}, action) => {
  switch (action.type) {
    case C.SET_UPLOAD_PROGRESS:
      return { ...state, progress: action.payload.progress }
    case C.SET_UPLOAD_STATUS:
      return { ...state, status: action.payload.status }
    case C.RESET_UPLOAD:
      return {}
    default:
      return state
  }
}

const reducers = {
  localProfileElements,
  environment,
  referral,
  products,
  user,
  registered,
  affiliate,
  arrival_times,
  completed,
  guest_kind,
  guest_kind_unknown_place,
  vaccinationInfo,
  vaccinationOptions,
  onshore,
  uploader
}

export default combineReducers({ ...reducers, ...sharedReducers })
